import { replaceParameters } from '@/common-utils/functions/restUtils';
import customizationFields from '@/app/modules/payludd/customization/fields/customizationFields';
import contractFields from '@/app/modules/contracts/fields/contractFields';

const { client } = require('@/common-utils/libraries/axios/axios');
const { default: PAYLUDD_BENEFICIARIES } = require('../apiUrls');

/**
 * @param responseData response.data object
 * @param responseData.items array
 * @param responseData.totalResults number
 *
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(beneficiary => {
        return {
            [customizationFields.BENEFICIARIES.NAME.key]: beneficiary[customizationFields.BENEFICIARIES.NAME.key],
            [customizationFields.BENEFICIARIES.COLOR.key]: beneficiary[customizationFields.BENEFICIARIES.COLOR.key],
            [customizationFields.BENEFICIARIES.CONTRACT_ACCESS.key]: beneficiary[customizationFields.BENEFICIARIES.CONTRACT_ACCESS.key],
            [customizationFields.BENEFICIARIES.CONTRACTS.key]: beneficiary[customizationFields.BENEFICIARIES.CONTRACTS.key].map(contract => ({
                [contractFields.APPLICATION.key]: contract[contractFields.APPLICATION.key],
                [contractFields.BANK_CODE.key]: contract[contractFields.BANK_CODE.key],
                [contractFields.NUMBER.altKey]: contract[contractFields.NUMBER.altKey],
                [contractFields.CREATED_AT.key]: contract[contractFields.CREATED_AT.key],
                [contractFields.MERCHANT_LABEL.key]: contract[contractFields.MERCHANT_LABEL.key],
                [contractFields.MERCHANT_LEGAL_NAME.key]: contract[contractFields.MERCHANT_LEGAL_NAME.key],
                [contractFields.MERCHANT_NAME.key]: contract[contractFields.MERCHANT_NAME.key],
                [contractFields.RANK.key]: contract[contractFields.RANK.key],
                [contractFields.UPDATED_AT.key]: contract[contractFields.UPDATED_AT.key],
                [contractFields.UUID.key]: contract[contractFields.UUID.key],
                [contractFields.IDSA.key]: contract[contractFields.IDSA.key],
                [contractFields.MCC.key]: contract[contractFields.MCC.key],
                [contractFields.REGISTRATION_NUMBER.key]: contract[contractFields.REGISTRATION_NUMBER.key]
            })),
            [customizationFields.BENEFICIARIES.CREATED_AT.key]: beneficiary[customizationFields.BENEFICIARIES.CREATED_AT.key],
            [customizationFields.BENEFICIARIES.UPDATED_AT.key]: beneficiary[customizationFields.BENEFICIARIES.UPDATED_AT.key],
            [customizationFields.BENEFICIARIES.UUID.key]: beneficiary[customizationFields.BENEFICIARIES.UUID.key]
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;

    return data;
}

const queryGetBeneficiaries = ({ contractAccessId }, enabled) => {
    return {
        queryKey: [PAYLUDD_BENEFICIARIES.PAYLUDD_BENEFICIARIES.queryKey, contractAccessId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(PAYLUDD_BENEFICIARIES.PAYLUDD_BENEFICIARIES.url, { contractAccessId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetBeneficiaries;